module.exports = __webpack_public_path__ + "static/media/redpacket-sm.0dc94fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/redpacket-sm.png
// module id = 1894
// module chunks = 6